module.exports = __webpack_public_path__ + "img/1-5-p3.d4a5cdb3.svg";